import { Appointment } from 'src/gql/graphql';
import { Button } from 'src/ui/components/Button';
import { Modal, ModalBase } from 'src/ui/components/Modal/Modal';
import { useGQLMutation } from 'src/ui/utils/graphql';
import { START_APPOINTMENT } from 'src/graphql/Appointments';
import styles from './StartAppointmentModal.module.scss';
import { Heading } from '../../../../../../ui/components/Heading/Heading';

interface StartAppointmentModalI extends ModalBase {
  appointment: Appointment;
}

export const StartAppointmentModal = ({
  appointment,
  isOpen,
  setIsOpen,
}: StartAppointmentModalI) => {
  const { mutation: startAppointmentMutation } = useGQLMutation<
    Appointment,
    { appointmentId: string; companyId: string }
  >(START_APPOINTMENT, {
    onCompleted: (data) => {
      console.log('Appointment started:', data);
      setIsOpen(false); // Close the modal after starting the appointment
    },
  });
  const handleStartAppointment = () => {
    startAppointmentMutation({
      variables: {
        appointmentId: appointment.id,
        companyId: appointment.Company.id,
      },
    });
  };

  return (
    <Modal
      className={styles.root}
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
    >
      <Heading headingLevel="h2" className={styles.heading}>
        ¿Está seguro de que desea iniciar la cita?
      </Heading>
      <div className={styles.actions}>
        <Button onClick={() => setIsOpen(false)}>Cancelar</Button>
        <Button btnStyle="secondary" onClick={handleStartAppointment}>
          Confirmar
        </Button>
      </div>
    </Modal>
  );
};
